var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStackedCoins(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 13.15V16.85C18.5 19.97 15.59 22.5 12 22.5C8.41 22.5 5.5 19.97 5.5 16.85V13.15C5.5 16.27 8.41 18.5 12 18.5C15.59 18.5 18.5 16.27 18.5 13.15Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 8.15C18.5 9.06 18.25 9.9 17.81 10.62C16.74 12.38 14.54 13.5 12 13.5C9.46 13.5 7.26 12.38 6.19 10.62C5.75 9.9 5.5 9.06 5.5 8.15C5.5 6.59 6.22999 5.18 7.39999 4.16C8.57999 3.13 10.2 2.5 12 2.5C13.8 2.5 15.42 3.13 16.6 4.15C17.77 5.18 18.5 6.59 18.5 8.15Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 8.15V13.15C18.5 16.27 15.59 18.5 12 18.5C8.41 18.5 5.5 16.27 5.5 13.15V8.15C5.5 5.03 8.41 2.5 12 2.5C13.8 2.5 15.42 3.13 16.6 4.15C17.77 5.18 18.5 6.59 18.5 8.15Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStackedCoins);
export default __webpack_public_path__ + "static/media/stacked-coins.6a40d6a6b1c8a6c0cbb5a5db9b620671.svg";
export { ForwardRef as ReactComponent };